import { useEffect, useRef } from 'react';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { trackEvent } from '@/Infrastructure/Utils/analytics/braze/brazeClient';
import { getOrderCompletedOnlinePayload } from '@/Infrastructure/Utils/analytics/braze/utils';

export const useSendOrderCompletedOnline = () => {
  const paymentSuccess = useAppSelector(
    (state) => state?.billing?.paymentSuccess
  );
  const cart = useAppSelector((state) => state?.cart?.data);
  const eventSentForOrderRef = useRef<string | null>(null);

  useEffect(() => {
    if (!cart || !cart.lineItems || !paymentSuccess) return;

    if (eventSentForOrderRef.current === paymentSuccess.id) return;

    const payload = getOrderCompletedOnlinePayload(cart, paymentSuccess);

    trackEvent('order_completed_online', payload);
    eventSentForOrderRef.current = paymentSuccess.id;
  }, [cart, paymentSuccess]);
};
